const routes = [{
  path: '/bi/page',
  component: () => import('@/views/dataManage/bi'),
  name: 'bi-page',
  meta: {
    title: ''
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/dataManage/bi.js